import * as types from "../types";

const initialState = {
  loading: false,
  firebaseData: null,
  requestDevice: null,
  error: null,
};

export default function fetchFirebaseDataReducer(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_FIREBASE_REQUEST:
      return {
        ...state,
        loading: true,
        requestDevice: action.payload.requestDevice,
      };

    case types.FETCH_FIREBASE_SUCCESS:
      return {
        ...state,
        loading: false,
        firebaseData: action.payload.firebaseData,
      };

    case types.FETCH_FIREBASE_FAILURE:
      return {
        ...state,
        loading: false,
        firebaseData: null,
        requestDevice: null,
        error: action.payload.error,
      };

    default:
      return state;
  }
}
